"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.portfolioSchema = void 0;
exports.portfolioSchema = {
    type: 'object',
    required: [
        'applicationID',
        'borrowerIncomeVerifiedIndicator',
        'creditAgencyReceivedFileNameOnMvs',
        'creditAgencyReceivedFileNameOnServer',
        'creditAgencySendFileNameOnMvs',
        'creditAgencySendFileNameOnServer',
        'creditAgencySinSendFileName',
        'dataSetReducedIndicator',
        'emiliLowRatioIndicator',
        'epipProcessingStatusCode',
        'inputDataSetName',
        'lastCommitmentInputRecordNumber',
        'lastStatusUpdateTimestamp',
        'loanSecurityTypeCode',
        'multipleComponentLoanIndicator',
        'poolMortgageFinancialProductTypeCode',
        'poolPrecisionTypeCode',
        'poolTargetAmount',
        'portfolioBundleTypeCode',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'recordCreatedTimestamp',
        'residenceOccupancyTypeCode',
        'selfEmployedSimplifiedIndicator',
        'tabDescriptionText',
        'totalLoanCount',
        'totalSubmittedLoanAmount',
        'underwritingApprovedLenderID',
        'validationSequenceNumber',
    ],
    properties: {
        portfolioID: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        applicationID: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
            default: 0,
        },
        portfolioSequenceNumber: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
            default: 0,
        },
        borrowerIncomeVerifiedIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
            default: '',
        },
        creditAgencyReceivedFileNameOnMvs: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 44,
            errorMessage: 'should have variable length up to 44 characters',
            default: '',
        },
        creditAgencyReceivedFileNameOnServer: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 350,
            errorMessage: 'should have variable length up to 350 characters',
            default: '',
        },
        creditAgencySendFileNameOnMvs: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 44,
            errorMessage: 'should have variable length up to 44 characters',
            default: '',
        },
        creditAgencySendFileNameOnServer: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 350,
            errorMessage: 'should have variable length up to 350 characters',
            default: '',
        },
        creditAgencySinSendFileName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 350,
            errorMessage: 'should have variable length up to 350 characters',
            default: '',
        },
        creditAgencySinSendFileTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000 or null',
        },
        creditBureauReceivedTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000 or null',
        },
        creditBureauSentTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000 or null',
        },
        dataSetReducedIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
            default: '',
        },
        emiliLowRatioIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
            default: '',
        },
        epipProcessingStatusCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        inputDataSetName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 44,
            errorMessage: 'should have variable length up to 44 characters',
            default: '',
        },
        inputFileProcessCompleteTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000 or null',
        },
        inputFileProcessStartTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000 or null',
        },
        lastCommitmentInputRecordNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
            default: 0,
        },
        lastStatusUpdateTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
            default: '1900-01-01 00:00:00.000000',
        },
        loanSecurityTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        multipleComponentLoanIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
            default: '',
        },
        poolMortgageFinancialProductTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        poolPrecisionTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        poolTargetAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and fixed 2 digits of significance',
            default: 0,
        },
        portfolioBundleTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
            default: '1900-01-01 00:00:00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
            default: '',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
            default: '1900-01-01 00:00:00.000000',
        },
        residenceOccupancyTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        selfEmployedSimplifiedIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
            default: '',
        },
        tabDescriptionText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 40,
            errorMessage: 'should have variable length up to 40 characters',
            default: '',
        },
        termInsuranceExpiryDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        termInsuranceYearCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        totalLoanCount: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
            default: 0,
        },
        totalSubmittedLoanAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and fixed 2 digits of significance',
            default: 0,
        },
        underwritingApprovedLenderID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
            default: '',
        },
        validationSequenceNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
            default: 0,
        },
    },
};
